import api from './api';
import { Category } from '../types';


export interface CreateCategoryData {
  name: string;
  slug: string;
  description?: string;
  is_active?: boolean;
  parent?: number | null;
}

// Normaliza respuestas (paginadas o listas) a arreglo simple
const toArray = (data: any): Category[] => {
  if (data && Array.isArray(data.results)) return data.results as Category[];
  if (Array.isArray(data)) return data as Category[];
  return [];
};

class CategoryService {
  async getAll(params?: Record<string, any>): Promise<Category[]> {
    const response = await api.get('products/categories/', { params });
    return toArray(response.data);
  }

  async create(data: CreateCategoryData): Promise<Category> {
    const response = await api.post('products/categories/', data);
    return response.data as Category;
  }

  async update(id: number, data: Partial<CreateCategoryData>): Promise<Category> {
    const response = await api.put(`products/categories/${id}/`, data);
    return response.data as Category;
  }

  async delete(id: number): Promise<void> {
    await api.delete(`products/categories/${id}/`);
  }
}

export const categoryService = new CategoryService();
export default categoryService;